// @flow
import styled from 'styled-components';
import Temperature from '~/components/widgets/temperature';

export const PickerContainer = styled.div`
    height: 100%;
    width: 100%;
`;

export const HeatLabel = styled(Temperature)`fill: rgb(231, 97, 54);`;

export const CoolLabel = styled(Temperature)`fill: rgb(69, 180, 271);`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/na-thermostat-dual/style.js